import { useQuery } from '@tanstack/react-query';
import { getDashboardSnapshot } from '../api/dashboard.api';

export function useDashboardV2Snapshot(
    projectId?: string,
    params?: {
        asOf?: string;
        viewAs?: 'DATE' | 'WEEK';
        evBasis?: 'CONFIRMED_W2' | 'CONFIRMED_W1' | 'LIVE';
    },
) {
    return useQuery({
        queryKey: ['dashboard-v2-snapshot', projectId, params?.asOf, params?.viewAs, params?.evBasis],
        enabled: !!projectId,
        queryFn: async () => {
            const res = await getDashboardSnapshot(projectId!, params);
            return res.data;
        },
    });
}
